import React from 'react'
import { Div, Faq, Text, TextLink } from 'ui/index'
import useResponsive from 'utils/hooks/useResponsive'
import { useTranslation, Trans } from 'react-i18next'
import { COINMARKETCAP_URL } from 'config/constants'


const Doubts = () => {

  const { isTab } = useResponsive()
  const { t } = useTranslation()

  return (
    <Div
      width='90%'
      margin='0 auto'
      maxWidth={775}
    >
      <Div marginBottom={32}>
        <Text size={isTab ? '2xl' : '4xl'} color='headline'>
          {t('flixx_doubts_title')}
        </Text>
      </Div>

      <Faq title={t('flixx_doubts_1_title')}>
        {t('flixx_doubts_1_description')}
      </Faq>
      <Faq title={t('flixx_doubts_2_title')}>
        {t('flixx_doubts_2_description')}
      </Faq>
      <Faq title={t('flixx_doubts_3_title')}>
        <Trans
          i18nKey={t('flixx_doubts_3_description')}
          components={(
            <TextLink
              isInline
              openNewTab
              to={{ pathname: COINMARKETCAP_URL}}
              size={isTab ? 'sm' : 'base'}
            />
          )}
        />
      </Faq>
      <Faq title={t('flixx_doubts_4_title')}>
        {t('flixx_doubts_4_description')}
      </Faq>


      <Text size={isTab ? 'sm' : 'base'}>
        <Trans
          i18nKey={t('flixx_doubts_faqs')}
          components={(
            <TextLink
              isInline
              openNewTab
              to={{ pathname: 'mailto:info@flixxo.com' }}
              size={isTab ? 'sm' : 'base'}
            />
          )}
        />
      </Text>
    </Div>
  )
}

export default Doubts